import { Injectable } from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {TasasVariables} from '../_models/tasas-variables';

@Injectable({
  providedIn: 'root'
})
export class TasasVariablesService {
  private rutaServicio = AppSettings.rutServiciosAPL + '/api/tasasVariables/';
  constructor( private httpClient: HttpClient, private autenticacionService: AutenticacionService) { }

  listado(): Observable<TasasVariables[]> {
    return this.httpClient.get( this.rutaServicio ).pipe( map( res => res as TasasVariables[] ) );
  }

  listadoHabilitado(): Observable<TasasVariables[]> {
    return this.httpClient.get( this.rutaServicio + 'enabled' ).pipe( map( res => res as TasasVariables[] ) );
  }

  obtenerPorId(idTasaVariable: string) {
    return this.httpClient.get( this.rutaServicio + idTasaVariable).pipe( map( res => res as TasasVariables ) );
  }

  listadoPrincipal() {
    return this.httpClient.get( this.rutaServicio + 'listarTasasVariablesConCondicion' ).pipe( map( res => res as any[] ) );
  }

  crear(registro: TasasVariables) {
    registro.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.post( this.rutaServicio, registro ).pipe( map( res => res as TasasVariables ) );
  }

  actualizar(regActualizar: TasasVariables) {
    regActualizar.auditoriaUsuario = this.autenticacionService.obtenerIdUsuarioLogueado();
    return this.httpClient.put( this.rutaServicio, regActualizar ).pipe( map( res => res as TasasVariables ) );
  }

  activar(idTasaVariable: string) {
    return this.httpClient.get( this.rutaServicio + 'lanzarTareaProgramadaTasasVariablesCondiciones/tasaVariable/' + idTasaVariable ).pipe( map( res => res as any) );
  }


}
